import React, { FC, ReactNode, useEffect, useState } from "react";
import "./drawerModal.scss";
import CloseModalIconSvg from "@app/neva/assets/svg/close-modal-icon.svg";
import Svg from "@natera/material/lib/svg";
import SuccessScreen from "@app/neva/components/drawerModal/components/successScreen";
import classNames from "classnames";

interface Props {
  children: ReactNode;
  closeHandler: () => void;
  showSuccessScreen?: boolean;
}

export const DrawerModal: FC<Props> = ({
  children,
  closeHandler,
  showSuccessScreen = false,
}) => {
  const [hasCloseAnimation, setHasCloseAnimation] = useState(false);
  const [hasOpenAnimation, setHasOpenAnimation] = useState(false);

  useEffect(() => {
    setHasOpenAnimation(true);
  }, []);

  const handleCloseModal = () => {
    setHasCloseAnimation(true);
    closeHandler();
  };

  const drawerModalContainerClassNames = classNames("drawer-modal__container", {
    "drawer-modal__container--open": hasOpenAnimation,
    "drawer-modal__container--close": hasCloseAnimation,
  });

  const drawerModalOverlayClassNames = classNames("drawer-modal__overlay", {
    "drawer-modal__overlay--open": hasOpenAnimation,
    "drawer-modal__overlay--close": hasCloseAnimation,
  });

  return (
    <div
      className={classNames("drawer-modal__wrapper", {
        "drawer-modal__wrapper--close": hasCloseAnimation,
      })}
    >
      <div className={drawerModalContainerClassNames}>
        {showSuccessScreen ? (
          <SuccessScreen handleCloseModal={handleCloseModal} />
        ) : (
          <>
            <div className="drawer-modal__header">
              <button
                className="drawer-modal__close-button"
                data-testid="header-close-button"
                onClick={handleCloseModal}
                aria-label="Close modal"
              >
                <Svg
                  className="drawer-modal__close-icon"
                  content={CloseModalIconSvg}
                  role="img"
                />
              </button>
            </div>
            {children}
          </>
        )}
      </div>
      <div className={drawerModalOverlayClassNames} />
    </div>
  );
};

export default DrawerModal;
